import { GenericError } from './genericError.mjs';

const NOT_FOUND_ERROR_TYPE = 'NotFoundError';
/**
 * Общий класс ошибок "Не найдено"
 *
 * @example
 *
 * ```ts
 * // Можно использовать как обертку над ошибкой FS ENOENT
 * function readPackageJson(cwd?: string): IResult<PackageJson, NotFoundError>;
 *
 * // Можно использовать как обертку на 404 статусом и 400 ошибкой с данными о том, что что-то не найдено
 * if (statusCode === 404) {
 *  return Err(new NotFoundError({ ..., details: err }));
 * }
 *
 * if (statusCode === 400 && response.err.notFound) {
 *  return Err(new NotFoundError({ ... }))
 * }
 * ```
 *
 * @export
 * @class NotFoundError
 * @extends {GenericError}
 */
class NotFoundError extends GenericError {
    static is(value) {
        return GenericError.is(value) && value.type === NOT_FOUND_ERROR_TYPE;
    }
    static isLike(value) {
        return GenericError.is(value) && Object.getPrototypeOf(value).constructor.name === NOT_FOUND_ERROR_TYPE;
    }
    constructor({ message, domain, details }) {
        super({
            type: NOT_FOUND_ERROR_TYPE,
            message,
            domain,
            details,
        });
        Object.setPrototypeOf(this, NotFoundError.prototype);
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, NotFoundError);
        }
        else {
            this.stack = new Error().stack;
        }
    }
}

export { NotFoundError };
//# sourceMappingURL=notFoundError.mjs.map
